import { RowTileBlock } from "@moim/blockit";
import { Spacer } from "@moim/common";
import * as React from "react";
import BlockitRendererV2 from "./components/blockitRenderer.v2";
import CoinGroup from "./components/coinGroup";
import CryptoBadges from "./components/cryptobadges";
import MyDQuests from "./components/dquests";
import MyShoppingSection from "./components/myShopping";
// components
import Positions from "./components/positions";
import UserContentGroupPreview from "./components/userContentGroupPreview";
import ProfileNftListPreview from "./components/userNfts/preview";
import { Section } from "./styledComponent";

interface IProps {
  userData: Moim.User.INormalizedUser | undefined;
  isMine: boolean;
  positions: Moim.Id[] | undefined;
  blocks: any[];
}

export const ProfileBlockRenderer: React.FC<IProps> = ({
  userData,
  isMine,
  blocks,
  positions,
}) => {
  return userData
    ? blocks?.map((block: any, index) => {
        switch (block.type as string) {
          case "my-shopping":
            return MyShoppingSection();

          case "my-quest": {
            if (isMine) {
              return (
                <MyDQuests key={`profile_show_block_${block.type}_${index}`} />
              );
            }
            return null;
          }

          case "nft-list-preview":
            return (
              <Section key={`profile_show_block_${block.type}_${index}`}>
                <Spacer value={12} />
                <ProfileNftListPreview userId={userData.id} />
                <Spacer value={12} />
              </Section>
            );
          case "positions":
            return (
              <Section key={`profile_show_block_${block.type}_${index}`}>
                <Spacer value={12} />
                <Positions positions={positions} />
                <Spacer value={12} />
              </Section>
            );
          case "badges":
            return (
              <Section key={`profile_show_block_${block.type}_${index}`}>
                <Spacer value={12} />
                <CryptoBadges
                  viewType={block.viewType}
                  user={userData}
                  issuers={block.issuers}
                />
                <Spacer value={12} />
              </Section>
            );

          case "coin-group":
            // const resourceId = (block as any).resourceId;
            // if (resourceId) {
            return (
              <Section key={`profile_show_block_${block.type}_${index}`}>
                <Spacer value={12} />
                <CoinGroup id={"resourceId"} /> <Spacer value={12} />
              </Section>
            );
            // }
            break;
          case "DQuest-list-preview": {
            return null;
          }
          case "user-contents-list": {
            return (
              <Section key={`profile_show_block_${block.type}_${index}`}>
                <Spacer value={12} />
                <UserContentGroupPreview
                  userId={userData.id}
                  types={block.children}
                  title={block.title}
                  pageTitle={block.pageTitle}
                />
              </Section>
            );
          }

          case "row-tile": {
            return (
              <Section key={`profile_show_block_${block.type}_${index}`}>
                <Spacer value={12} />
                <RowTileBlock {...block} />
                <Spacer value={12} />
              </Section>
            );
          }

          default:
            return (
              <BlockitRendererV2 key={`${block.type}_${index}`} block={block} />
            );
        }
      })
    : null;
};
